<template>
  <button class="h-30px bo-1px bor-100px cursor-pointer" ripple="ripple">
    <p class="lh-100 pl-22px pr-22px" 
      :class="[
        (p != '' ? `pl-${p} pr-${p}` : ''), 
        (p != '' ? `f-${f}` : 'f-14px'),
      ]">{{this.value}}</p>
  </button>
</template>

<script>
export default {
  name: 'Ic_button',
  extends: {},
  props: {
    value: { //text value
      type: String,
      required: true
    },
    p: { //padding
      type: String,
      required: false
    },
    f: { //font-size
      type: String,
      required: false
    }
  },
  data(){
    return{};
  },
  components: {},
  computed: {},
  watch: {},
  methods: {},
  beforeCreate(){},
  mounted(){}
}
</script>
